function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.664 2.334a1.344 1.344 0 00-1.898 0l-.755.753L12.91 4.98l.755-.753a1.338 1.338 0 000-1.894zm.667 2.56a2.278 2.278 0 000-3.226 2.288 2.288 0 00-3.232 0l-1.088 1.086-8.873 8.857a.47.47 0 00-.138.333v2.585c0 .26.211.471.472.471H4.01c.125 0 .245-.05.334-.138l9.987-9.968zm-2.089.753l-1.897-1.895-8.402 8.387v1.92h1.872l8.427-8.412z",
  fill: "#2D2D2D"
});
function SvgLapiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Lapiz.svg";
export { SvgLapiz as ReactComponent };